import React, { useState } from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import { connect } from "react-redux";
import withStyles from "isomorphic-style-loader/lib/withStyles";

import s from "./Account.scss";

import { sidebar } from "../../../../configPublic";

import Layout from "../../../../components/Layout";
import FormManager from "../../../../components/FormManager";
import Form from "../../../../components/Form";
import Text from "../../../../components/Form/Input/Text";
import Password from "../../../../components/Form/Input/Password";
import Avatar from "../../../../components/Form/Input/Avatar/Avatar";
import {
  isValidPassword,
  PASSWORD_HELP_TEXT,
  PASSWORD_ERROR_TEXT,
} from '../../../../core/passwordPolicy';

const Account = ({ title, siteId, sidebarKey, userData }) => {
  const [isShowPasswordUpdate, setIsShowPasswordUpdate] = useState(false);

  const timezoneNames = moment.tz
    .names()
    .filter(
      name =>
        name.startsWith("US/") ||
        name.startsWith("Canada/") ||
        name.startsWith("Europe/")
    );
  const timezoneOptions = timezoneNames.map(name => ({
    value: name,
    label: name
  }));

  timezoneOptions.unshift({
    value: "",
    label: ""
  });

  const formManager = (
    <FormManager
      // title={title}
      getQueryString={(graphQLModule, fieldsQuery) => `{
        item: ${graphQLModule} {
          details: user { ${fieldsQuery.join(" ")} }
        }
      }`}
    >
      <Form metaData={{ graphQLModule: "me" }}>
        <Avatar
          accept="image/*"
          helpText=""
          errorText="some error text"
          name="avatar"
          uploadPath={`/${siteId}/upload?visibility=public`}
          filePath={`/${siteId}/asset`}
          validators=""
          subfieldsQuery={() => ({
            media: { _id: 1, ext: 1 },
            focalSelector: 1
          })}
          valueTransformOut={value => {
            if (!value) return value;
            const updatedValue = Object.assign({}, value);
            delete updatedValue.media.ext;
            return updatedValue;
          }}
        />
        {isShowPasswordUpdate ? (
          <Password
            label="New Password"
            autoComplete="new-password"
            helpText={PASSWORD_HELP_TEXT}
            errorText={PASSWORD_ERROR_TEXT}
            name="password"
            // Blank leaves the current password in place, so only validate
            // once the user has actually typed something.
            validators={val =>
              `${val}`.length === 0 || isValidPassword(`${val}`)
            }
          />
        ) : (
          <div>
            <Text
              label="First Name"
              helpText=""
              errorText=""
              name="firstname"
              required
            />
            <Text
              label="Last Name"
              helpText=""
              errorText=""
              name="lastname"
              required
            />
            <Text
              label="Email Address"
              helpText=""
              errorText="Valid email address required."
              name="email"
              validators="isEmail"
              required
            />
          </div>
        )}
      </Form>
    </FormManager>
  );

  return (
    <Layout sidebar={sidebar[sidebarKey]}>
      <div className="content__body">
        <div className="Account">
          <div className="Account__header">
            <h1 className="Account__title">Hello {userData.firstname},</h1>
            <div className="Account__desc">
              {isShowPasswordUpdate
                ? "Update your password"
                : "Edit your Account’s informations"}
            </div>
          </div>

          <div className="Account__body">
            {formManager}

            {isShowPasswordUpdate ? (
              <button
                className="Account__link"
                type="button"
                onClick={() => setIsShowPasswordUpdate(false)}
              >
                Back to Edit
              </button>
            ) : (
              <button
                className="Account__link"
                type="button"
                onClick={() => setIsShowPasswordUpdate(true)}
              >
                Update your password?
              </button>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

Account.propTypes = {
  title: PropTypes.string.isRequired,
  siteId: PropTypes.string.isRequired,
  sidebarKey: PropTypes.string.isRequired,
  userData: PropTypes.shape({
    firstname: PropTypes.string
  })
};

Account.defaultProps = {
  userData: null
};

const mapStateToProps = state => {
  const session = state.session;
  return {
    userData: session.USER_DATA
  };
};

export default connect(mapStateToProps)(withStyles(s)(Account));



// WEBPACK FOOTER //
// ./src/routes/client/site/account/Account.js